import { getPaymentMethod, postPaymentMethod } from '@front/common/endpoints'
import { useStore, useVuex } from '@vueblocks/vue-use-vuex'

import useApiState from '@member-area/core/hooks/useApiState'
import useAuth from '@member-area/middleware/auth.hook'

import { INSERT_PAYMENT_METHOD } from './constants'

export default function usePaymentMethod() {
  const store = useStore()
  const { useGetters } = useVuex()
  const { auth } = useAuth()

  const [
    _onFetchPaymentMethodSuccess,
    fetchPaymentMethodState,
    fetchPaymentMethodAction,
  ]: any[] = useApiState(getPaymentMethod)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, addPaymentMethodState, addPaymentMethodAction]: any[] =
    useApiState(postPaymentMethod)

  async function fetchPaymentMethod() {
    const data = await fetchPaymentMethodAction(auth.value.id)

    store.commit(INSERT_PAYMENT_METHOD, data)
  }

  async function addPaymentMethod({ cardNumber, stripe, method = 'card' }) {
    const { data } = await addPaymentMethodAction(method, auth.value.id)

    await fetchPaymentMethod()

    const { error } = await stripe.confirmCardSetup(data.clientSecret, {
      payment_method: {
        card: cardNumber,
      },
    })

    if (error) {
      throw new Error(error.message)
    }
  }

  return {
    ...(useGetters({
      paymentMethod: 'paymentMethod/get',
    }) as any),
    fetchPaymentMethodState,
    addPaymentMethodState,
    fetchPaymentMethod,
    addPaymentMethod,
  }
}
